<template>
  <!-- 数据统计-对战统计 -->
  <div class="battle_statistics-box">
    <!-- header头部 -->
    <header>
      <el-form :inline="true" :model="query" class="demo-form-inline">
        <el-form-item>
          <el-date-picker style="width: 200px" v-model="query.start_time" type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss" placeholder="开始时间">
          </el-date-picker>
          ->
          <el-date-picker style="width: 200px" v-model="query.end_time" type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss" placeholder="结束时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" class="add-btn" style="margin-right: 20px" @click="exportUserAmount">导出用户金额
          </el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" class="add-btn" style="margin-right: 20px" @click="handleExport">导出保证金
          </el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" class="add-btn" style="margin-right: 20px" @click="exportUnpackingData">导出开箱数据
          </el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" class="add-btn" style="margin-right: 20px" @click="handleExportIGOrder">导出IG订单
          </el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" class="add-btn" style="margin-right: 20px" @click="handleExportBill">导出对账单
          </el-button>
        </el-form-item>
        <el-form-item>
          <el-date-picker v-model="battleTime" align="right" type="date" placeholder="选择日期"
            :picker-options="pickerOptions">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" class="add-btn" style="margin-right: 20px" @click="exportDailyData">导出对战每日数据
          </el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" class="add-btn" style="margin-right: 20px" @click="exportYesterdayRecharge">导出昨日充值
          </el-button>
        </el-form-item>
      </el-form>
    </header>
    <!-- body内容 -->
    <div class="body-box"></div>

    <!-- 弹窗 -->
  </div>
</template>

<script>
import {
  mapState,
  mapMutations,
  mapActions
} from 'vuex'
import http, {
  api,
  getData,
  delApiData,
  getApiData,
  postApiData,
  patchApiData
} from '../../http'
import saveFile from '@/utils/saveFile'

export default {
  name: 'battle_statistics',
  components: {},
  data() {
    return {
      loading: false, //页面数据加载动画
      buttonLoading: false, //按钮加载动画
      dialogLoading: false, //弹窗加载数据动画
      query: { //页面查询条件
        page: 1,
        start_time: undefined,
        end_time: undefined
      },
      battleTime: undefined, //对战每日数据统计时间
      dataMeta: undefined, //底部跳转页面条
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: [{
          text: '今天',
          onClick(picker) {
            picker.$emit('pick', new Date());
          }
        }, {
          text: '昨天',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24);
            picker.$emit('pick', date);
          }
        }, {
          text: '一周前',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', date);
          }
        }]
      },
    }
  },
  computed: {
    ...mapState({})
  },
  watch: {},
  created() { },
  mounted() { },
  methods: {
    ...mapMutations(['']),
    ...mapActions(['']),
    exportUserAmount() {
      //导出用户金额
      window.open(`${api}export_battle_user?start_time=${this.query.start_time}&end_time=${this.query.end_time}`)
    },
    exportUnpackingData() {
      //导出开箱数据
      window.open(`${api}export_battle_sta?start_time=${this.query.start_time}&end_time=${this.query.end_time}`)
    },
    exportDailyData() {
      //导出对战每日数据
      if(!this.battleTime){
        this.$message.warning("请先选择日期")
        return
      }
      const d = new Date(this.battleTime)
      const resDate = d.getFullYear() + '-' + this.supplement((d.getMonth() + 1)) + '-' + this.supplement(d.getDate())
      window.open(`${api}export_battle_day_data?date=${resDate}`)
    },
    exportYesterdayRecharge() {
      //导出昨日充值
      window.open(`${api}export_battle_yesterday_recharge`)
    },
    handleExport() {
      //导出保证金
      if (!this.query.start_time) {
        this.$message.warning("开始时间必填")
        return
      }
      let params = this.query
      http
        .post(
          api + 'ig_ensure_export',
          { ...params },
          {
            responseType: 'arraybuffer'
          }
        )
        .then(res => {
          saveFile(res, {
            type:
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            name: '保证金.xlsx'
          })
        }).finally(() => {
        })
    },
    handleExportIGOrder() {
      //导出IG订单
      if (!this.query.start_time) {
        this.$message.warning("开始时间必填")
        return
      }
      let params = this.query
      http
        .post(
          api + 'ig_order_history_export',
          { ...params },
          {
            responseType: 'arraybuffer'
          }
        )
        .then(res => {
          saveFile(res, {
            type:
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            name: 'IG历史订单.xlsx'
          })
        }).finally(() => {
        })
    },
    handleExportBill() {
      //导出对账单
      // if (!this.query.start_time) {
      //   this.$message.warning("开始时间必填")
      //   return
      // }
      let params = this.query
      http
        .post(
          api + 'ig_reconciliation_export',
          { ...params },
          {
            responseType: 'arraybuffer'
          }
        )
        .then(res => {
          saveFile(res, {
            type:
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            name: '对账单.xlsx'
          })
        }).finally(() => {
        })
    },
    supplement(s) {
      return s < 10 ? '0' + s : s
    },
  },
}

</script>

<style lang="less" scoped>
.battle_statistics-box {
  header {}

  .body-box {}
}
</style>
